export const isOfType = (type: string, val: any):
boolean => (val.constructor
    && val.constructor.name.toLowerCase() === type.toLowerCase());

export const isObjectChanged = (prevObj: any, newObj: any):
boolean => JSON.stringify(prevObj) !== JSON.stringify(newObj);
